import { LoseObject } from '../types/configs';
import { getConfig } from './config';

/**
 * getInitialData
 * helper for getting and setting initial data passed to the analytics wrapper as config
 * @param {Object} _initialData
 */
// interface LoseObject {
//   [key: string]: any;
// }

const getInitialData = (_initialData?: any) => {
  let initialData: LoseObject = {};
  const obj: LoseObject = {};

  if (!_initialData && getConfig().initialData)
    initialData = getConfig().initialData;

  if (!initialData) throw new Error('QAL Error: No initial data found');

  Object.keys(initialData).forEach((key) => {
    if (initialData[key]) obj[key] = initialData[key];
  });

  return initialData;
};

export default getInitialData;
